module.exports = __webpack_public_path__ + "static/index/img/baikal-204.5eb1075c.jpg";